import React, { useState, useEffect, useMemo } from 'react'
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import CustomPagination from '../../../components/company_panel/common/custompagination'
import Sorting from '../../../components/company_panel/common/sorting';
import Loader from '../../../components/company_panel/common/loader'
import $ from "jquery";
import { capitalizeFirstLetter, checkPermission, formateDate, getBrandId } from '../../../helpers/commonFunctions';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfigurationTab from '../configurationTab';
import { ChangeMenuItemsStatus, DeleteMenuItems } from '../../../services/company_panel/menuItems';
import CustomRangepicker from '../../../components/company_panel/common/rangepicker';
import StatusFilter from '../../../components/company_panel/common/statusFilter';
import { showFilterlist } from '../../../utils/Constants';
import { ChangeStatusMeals, DeleteMeals, ListMeals } from '../../../services/company_panel/mealService';
import notFound from '../../../assets/company/img/no-record-found.png'
import { usePersistedListState } from '../../../hooks/usePersistedListState';


const MealsAndCombosList = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/company/dashboard" }, { title: "Pages", url: "" },];
    const navigate = useNavigate();
    const [submitted, setSubmitted] = useState(false);
    const params = useParams();
    const location = useLocation();
    // persisted filters (page lives in the route) — restored on return from add/edit/view
    const { saved, save, clear } = usePersistedListState('meal_combos');
    const [list, setList] = useState([]);
    const [statsUpdate, setStatusUpdate] = useState("false");
    const [dataLength, setDataLength] = useState();
    const [itemPerPage, setItemPerPage] = useState(saved?.itemPerPage || 10);
    const [sorting, setSorting] = useState(saved?.sorting || {});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(Number(params?.id) || 1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState(saved?.search || {});
    const [globalSearch, setGlobalSearch] = useState(saved?.globalSearch || "");
    const [resetdate, setResetDate] = useState(false);
    const [isBrandChanged, setIsBrandChanged] = useState(false);

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
    });


    useEffect(() => {
        if (search) {
            setLoader(true)
            const formData = new FormData()
            formData.append("page", page)
            formData.append("per_page", itemPerPage)
            formData.append("sort", JSON.stringify(sorting))
            formData.append("search", JSON.stringify(search))
            formData.append("global_search", globalSearch)
            formData.append('brand_id', getBrandId());
            ListMeals(formData).then(data => {
                setDataLength(data.data.response.count);
                setList(data && data.data && data.data.response ? data.data.response.rows : [])
                setLoader(false)
            }).catch(error => {
                console.log("error ====> ", error);
            })
        }
    }, [location, statsUpdate, sorting, search, globalSearch, isBrandChanged])

    // persist filters on every change (page lives in the route, not the store)
    useEffect(() => {
        save({ itemPerPage, sorting, search, globalSearch });
    }, [itemPerPage, sorting, search, globalSearch])

    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSearch({})
        setResetDate(!resetdate)
        $("#defaultstatus").prop("selectedIndex", 0)
        clear()
    }

    function deleteFunction(row) {
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const formdata = new FormData()
                formdata.append("id", row)
                DeleteMeals(formdata).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: 'Meal/Combo deleted successfully',
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                    }
                }).catch(error => {
                    console.log("deleteError")
                })
            }
        })
    }

    const ChangeStatus = (row, Num) => {
        const formData = new FormData()
        formData.append("id", row)
        formData.append("status", Num)
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                ChangeStatusMeals(formData).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: data.data.message,
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                    }
                }).catch(error => {
                    console.log("error===>")
                })
            }
        })
    }

    const handleEdit = (id) => {
        navigate(`/company/menu/menu/meals_combos/${params.id}/edit/${id}`);
    }
    const handleView = (id) => {
        navigate(`/company/menu/menu/meals_combos/${page}/view/${id}`);
    }
    const copyOutletFunction = (row) => {
        navigate(`/company/menu/menu/meals_combos/${params.id}/edit/${row.id}?copy=true`);
    }
    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }

    return (
        <>
            <div className="animation_fade">

                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Menu</h4>
                    </div>
                    <div className='page-header-right ms-auto'>

                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20 border-bottom'>
                        <div className='col-12'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <ConfigurationTab tab='mealsCombos' />
                            </div>
                        </div>
                    </div>
                    <div className="gap-20">
                        <div className='page-header d-flex align-items-center mb-0'>
                            <div className='page-header-left'>

                                <div className='gap-2'>
                                    <div className='filter-header d-flex justify-content-between align-items-center'>
                                        <div className='d-flex gap-3 align-items-center'>
                                            <div className="form-group mb-0 rangepicker_container">
                                                <input
                                                    type="search"
                                                    className="form-control"
                                                    value={globalSearch}
                                                    placeholder="Search"
                                                    onChange={(e) => { setGlobalSearch(e.target.value) }}
                                                />
                                            </div>
                                        </div>
                                        <div className='d-flex gap-4 align-items-center' style={{ marginLeft: '10px' }} >
                                            <StatusFilter
                                                data={showFilterlist}
                                                prepareSearch={prepareSearch}
                                                value={search.status === undefined ? '' : String(search.status)}
                                            />
                                            <div className="date-input">
                                                <CustomRangepicker
                                                    GetDateRange={(e) => { prepareSearch("created", e) }}
                                                    resetdate={resetdate}
                                                />
                                            </div>
                                            <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='page-header-right ms-auto'>
                            {checkPermission('store_menu_meal_combos', 'add') ?
                                <button className="btn btn-primary" type="button" onClick={(e) => navigate(`/company/menu/menu/meals_combos/${page}/add`)}>Create Meals</button>
                                : '' }
                            </div>
                        </div>
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>
                                        <th width="5%">
                                            <div className='d-inline-flex align-items-start'>
                                                <span className='me-2'>Id</span>
                                                <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="id" />
                                            </div>
                                        </th>
                                        {/* <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Sr no.</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="id" />
                                            </div>
                                        </th> */}
                                        <th width="15%">
                                            <div className='sorting_column'>
                                                <span>Name</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="name" />
                                            </div>
                                        </th>
                                        <th width="15%">
                                            <div className='sorting_column'>
                                                <span>Name (arabic)</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="name_ar" />
                                            </div>
                                        </th>
                                        <th className="created_head" width="10%">
                                            <div className='sorting_column'>
                                                <span>Created Date</span>
                                                <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="created_at" />
                                            </div>
                                        </th>
                                        <th className='status_head text-center' width="10%">Status</th>
                                        <th className='action_head text-end' width="10%">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={11}><Loader /></td>
                                        </tr> : <>
                                            {list.length ? list?.map((row, i) => (
                                                <tr key={i}>
                                                    <td>{row.id}</td>
                                                    {/* <td>{i + 1}</td> */}
                                                    <td>{capitalizeFirstLetter(row?.name)}</td>
                                                    <td>{capitalizeFirstLetter(row?.name_ar)}</td>
                                                    <td>{row.created_at ? formateDate(row.created_at) : "N/A"}</td>
                                                    <td>
                                                        <div className="form-check form-switch w-25 mx-auto">
                                                            <input className="form-check-input" type="checkbox" id="status-change" name="status" checked={row.status == 1 ? 'checked' : ''} onClick={() => { ChangeStatus(row.id, row.status == 1 ? 0 : 1) }} />
                                                            <label className="form-check-label" for="status-change"></label>
                                                        </div>
                                                    </td>
                                                    <td className='text-end'>
                                                        <div className="dropdown  d-inline-block">
                                                            <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className='ti ti-dots-vertical'></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                            {checkPermission('store_menu_meal_combos', 'view') ?
                                                                <li><div className='dropdown-item' onClick={() => { handleView(row.id) }}><i className="ti ti-eye" aria-hidden="true"></i> View</div></li>
                                                                : '' }
                                                                {checkPermission('store_menu_meal_combos', 'edit') ?
                                                                <li><div className='dropdown-item' onClick={() => { handleEdit(row.id) }}><i className="ti ti-edit" aria-hidden="true"></i> Edit</div></li>
                                                                : '' }
                                                                {checkPermission('store_menu_meal_combos', 'delete') ?
                                                                <li> <div className='dropdown-item' onClick={() => { deleteFunction(row.id) }}><i className="ti ti-trash" aria-hidden="true"></i> Delete</div></li>
                                                                : '' }
                                                                {checkPermission('store_menu_meal_combos', 'add') ?
                                                                <li> <div className='dropdown-item' onClick={() => { copyOutletFunction(row) }}><i className="ti ti-copy" aria-hidden="true"></i> Copy meal combos</div></li>
                                                                :''}
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) : <tr>
                                                <td colSpan={11} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No record found</p>
                                                </td>
                                            </tr>
                                            }</>}
                                </tbody>

                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "outlet-management", path: "/company/menu/menu/meals_combos/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer
                    position="top-right"
                    hideProgressBar={false}
                    autoClose={true | 1000}
                    newestOnTop={true}
                    closeOnClick={false}
                    draggable={false}
                    rtl={false}
                />
            </div>
        </>
    );
}

export default MealsAndCombosList;